import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/job-categories";

const jobCategoryApi = {
  getJobCategories(params?: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default jobCategoryApi;
